import { useRange } from "react-instantsearch";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { useEffect, useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@repo/ui/components/ui/accordion";

export default function AlgoliaRangeInput({
  attribute,
  title,
}: {
  attribute: string;
  title: string;
}) {
  const { start, range, canRefine, refine } = useRange({ attribute });
  const safeNumber = (value: unknown, fallback: number): number =>
    typeof value === "number" && Number.isFinite(value) ? value : fallback;

  const min = safeNumber(range.min, 0);
  const max = safeNumber(range.max, 1000);

  const from = safeNumber(start[0], min);
  const to = safeNumber(start[1], max);

  const [value, setValue] = useState<[number, number]>([from, to]);

  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  useEffect(() => {
    setValue([from, to]);
  }, [from, to]);

  if (min === max) return null;

  return (
    <Accordion type="single" collapsible>
      <AccordionItem value="item-1">
        <div className="py-[16px]">
          <AccordionTrigger className="max-md:text-base font-medium py-0 data-[state=open]:text-primary-magenta">
            {title}
          </AccordionTrigger>
          <AccordionContent className="mt-[20px] pb-0">
            <div className="flex justify-end mb-6">
              <span className="block font-bold">
                {formatter.format(value[0]).replace(",", ".")}€ -{" "}
                {formatter.format(value[1]).replace(",", ".")}€
              </span>
            </div>
            <SliderPrimitive.Root
              className="relative flex w-full touch-none select-none items-center mb-10"
              min={min}
              max={max}
              step={1}
              value={value}
              onValueChange={(next) => setValue(next as [number, number])}
              onValueCommit={(next) => refine(next as [number, number])}
              disabled={!canRefine}
            >
              <SliderPrimitive.Track
                data-vaul-no-drag
                className="relative h-2 w-full grow overflow-hidden rounded-full bg-secondary-gray3"
              >
                <SliderPrimitive.Range className="absolute h-full bg-primary-magenta" />
              </SliderPrimitive.Track>
              <SliderPrimitive.Thumb
                data-vaul-no-drag
                className="block h-5 w-5 rounded-full  bg-primary-black dark:bg-primary-white ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
              />
              <SliderPrimitive.Thumb
                data-vaul-no-drag
                className="block h-5 w-5 rounded-full  bg-primary-black dark:bg-primary-white ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
              />
            </SliderPrimitive.Root>
          </AccordionContent>
        </div>
      </AccordionItem>
    </Accordion>
  );
}
